import { Box, Popover, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange,
  label,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleButtonClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (triggerRef.current) {
      triggerRef.current.focus();
    }
    if (inputValue !== value) {
      onChange(inputValue);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    // if (/^#([0-9A-F]{3}){1,2}$/i.test(newValue)) {
    //   onChange(newValue);
    // }
  };

  const open = Boolean(anchorEl);

  return (
    <Stack spacing={1}>
      {label && <Typography variant="body2">{label}</Typography>}
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          size="small"
          value={inputValue}
          placeholder="Enter #hexcolorcode"
          sx={{ flexGrow: 1 }}
          onChange={handleInputChange}
          slotProps={{
            htmlInput: { maxLength: 7 },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleClose();
            }
          }}
          onBlur={handleClose}
        />
        <Box
          ref={triggerRef}
          tabIndex={0}
          sx={{
            width: 37,
            height: 37,
            borderRadius: 1,
            backgroundColor: inputValue,
            border: "1px solid #ccc",
          }}
          onClick={handleButtonClick}
        />
      </Stack>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          <HexColorPicker
            color={value}
            onChange={(newColor) => {
              setInputValue(newColor);
            }}
          />
        </Box>
      </Popover>
    </Stack>
  );
};

export default ColorPicker;
